// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizedLayout_content__AngNr","mainPanel":"AuthorizedLayout_mainPanel__2npdR","adaptive":"AuthorizedLayout_adaptive__2EBCw"};